module.exports = {
      id: "6a5aa33fd4321c82679a917e2ea2f4eaequipment-ventilator-system.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#6a5aa33fd4321c82679a917e2ea2f4eaequipment-ventilator-system.svg",
      toString: function () {
        return this.url;
      }
    }